<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Surat Tugas</h3>
                <div class="font-medium text-500 mb-3">
                    Rincian Surat Penugasan Karyawan
                </div>
                <div v-if="isEdit" class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >No Surat</label
                    >
                    <InputText
                        id="is_present"
                        v-model="form.letter_no"
                        name="is_present"
                    />
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Tgl Penugasan</label
                    >
                    <Calendar
                        :showIcon="true"
                        :showButtonBar="true"
                        :class="{
                            'p-invalid': submitted && !form.assignment_date,
                        }"
                        v-model="form.assignment_date"
                        dateFormat="yy-mm-dd"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !form.assignment_date"
                        >Assignment Date is required.</small
                    >
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Keperluan</label
                    >
                    <Textarea
                        id="purpose"
                        rows="4"
                        cols="40"
                        v-model="form.purpose"
                    />
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Penempatan</label
                    >
                    <Dropdown
                        v-model="form.placement_id"
                        :options="placements"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Placement"
                    />
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Nama Karyawan</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedEmployee"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectApprovedBy"
                        field="name"
                        :class="{
                            'p-invalid': submitted && !selectedEmployee,
                        }"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !selectedEmployee"
                    >
                        Created By is required.
                    </small>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Posisi</label
                    >
                    <Dropdown
                    :class="{ 'p-invalid': submitted && !form.position_id }"
                    v-model="form.position_id"
                    :options="positions"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Position"
                    required="true"
                    />
                    <small class="p-invalid" v-if="submitted && !form.position_id">
                        {{ $t("position") }} is required.
                    </small>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >PIC</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedPic"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectPicId"
                        field="name"
                        :class="{ 'p-invalid': submitted && !selectedPic }"
                    />
                    <small class="p-invalid" v-if="submitted && !selectedPic">
                        PIC is required.
                    </small>
                </div>
                <div class="field grid">
                    <label for="name" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Daftar Kesalahan</label>
                    <ckeditor
                        id="mistakes"
                        required="true"
                        :editor="editor"
                        v-model="form.cc"
                        :config="editorConfig"
                        :autoResize="true"
                        :class="{ 'p-invalid' : submitted && !form.cc }">
                    </ckeditor>
                    <small class="p-invalid" v-if="submitted && !form.cc"
                        >CC is required.</small
                    >
                </div>
                <Button
                    :loading="isSaving"
                    @click="save"
                    id="button1"
                    label="Save"
                />
            </div>
        </div>
    </div>
</template>
<script>
import AppLayoutVue from "../../../Layouts/AppLayout.vue";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Textarea from "primevue/textarea";
import axios from "axios";
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    layout: AppLayoutVue,
    components: {
        AutoComplete,
        Button,
        Calendar,
        Checkbox,
        Dropdown,
        InputText,
        InputNumber,
        Textarea,
        ckeditor: CKEditor.component,
    },
    data() {
        return {
            form: this.$page.props.instruction ?? {
                base_of : "DITUGASKAN",
                purpose : "Ditugaskan Di PT ...",
                cc      : "<ul><li>Building Manager PT. Akum</li></ul><ul><li>HR Manager PT. Akum</li></ul><ul><li>Operational Manager PT. Akum</li></ul>",
            },
            placements: {},
            positions: {},
            submitted: false,
            autoFilteredValue: [],
            selectedEmployee: this.$page.props.instruction
                ? this.$page.props.instruction.employee
                : "",
            selectedPic: this.$page.props.instruction
                ? this.$page.props.instruction.pic
                : "",
            isEdit: this.$page.props.instruction ? true : false,
            isSaving: false,
            editor: ClassicEditor,
            editorConfig: {
                // The configuration of CKEditor
            },
        };
    },
    computed: {
        totalFee() {
            return (this.form.amount * 8.5) / 100;
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectApprovedBy() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedEmployee.id}`
                )
                .then((data) => {
                    this.form.employee_id = this.selectedEmployee.id;
                });
        },
        selectPicId() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedPic.id}`
                )
                .then((data) => {
                    this.form.pic_id = this.selectedPic.id;
                });
        },
        initData() {
            axios
                .get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios
                .get(`${this.$page.props.appUrl}api/positions`)
                .then((data) => {
                    this.positions = data.data;
                });
        },
        clearForm() {
            this.form = {
                description:
                    "Pembayaran Tagihan Tenaga Security Sebanyak xx orang (Anggota) Periode :xx - xx November 2022",
                amount: 0,
                is_pph: true,
                is_ppn: true,
            };
            this.selectedEmployee = "";
        },
        save() {
            this.isSaving = true;
            this.submitted = true;

            if (this.isEdit) {
                axios
                    .put(
                        `${this.$page.props.appUrl}api/letters/instructions/${this.$page.props.instruction.id}`,
                        this.form
                    )
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Instruction Updated",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Updating Instruction",
                            detail: error,
                            life: 3000,
                        });
                    });
            } else {
                axios
                    .post(`${this.$page.props.appUrl}api/letters/instructions`, this.form)
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Instruction Created",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Creating Instruction",
                            detail: error,
                            life: 3000,
                        });
                    });
            }

            this.isSaving = false;
        },
    },
};
</script>
